const NS = 'GlossaryBlock';
const CLS = 'glossaryBlock';

import { mediaQuery } from '../../../../global/js/wlc/mediaQuery';

export class GlossaryBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$navigation = this.$element.find(`.${CLS}-nav`);
		this.$card = this.$element.find(`.${CLS}-card`);
		this.mediaQuery = mediaQuery;

		this.createFilters();
		this.initFilterEvents();

		$(window).resize(_.debounce(() => {
			this.adjustHeight();
		}, 50));

		this.adjustHeight();

		this.$element.css({
			visibility: 'visible'
		});

		this.$card.css({
			visibility: 'visible'
		});
	}

	createFilters() {
		let navItemsMarkup = () => {
			let list = ``;
			// ASCII increments for letters from A–Z.
			for(let i = 65; i <= 90; i++) {
				list += `<li class="${CLS}-nav-item nav-item"><a class='${CLS}-nav-link nav-link ${i === 65 ? 'active' : ''}' href="#">${String.fromCharCode(i)}</a></li>`;
			}
			return list;
		};

		this.$navigation.html(navItemsMarkup());
	}

	initFilterEvents() {
		this.$navigationLink = this.$navigation.find('.nav-link');
		this.filterSelection('A');

		this.$navigationLink.on('click', (event) => {
			event.preventDefault();
			this.$navigationLink.removeClass('active');
			$(event.target).addClass('active');
			let labelSelect = $(event.target).html();
			this.filterSelection(labelSelect);
		});
	}

	filterSelection(character) {
		let $glossaryItem = this.$element.find('.glossaryItemBlock');
		$glossaryItem.map((index, element) => {
			let title = $(element).find('.glossaryItemBlock-title').html();
			$(element).toggle(character.toLowerCase() === title.charAt(0).toLowerCase());
		});
	}

	adjustHeight() {
		if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.LG)) {
			this.$element.css({
				height: `${this.$navigation.height()}px`
			});
		}
		else {
			this.$element.css({
				height: 'unset'
			});
		}
	}
}
